/**
 * The earlier thread (`/history`, 2026-10-12). A screen's thread is in its
 * memory: after a reload or a `/clear`, the messages are on the server only.
 * The command reads the newest page of them into the thread — the cleared
 * ones too, with each request and job box in its place — and a scroll to the
 * top reads the page before. It changes no row: the agent's context is still
 * what was said since the last `/clear`.
 */
import { api } from "../api/client";
import { ok } from "../api/query";
import { useChat } from "./store";

export const PAGE = 50;

async function page(before: number | null) {
  return ok(
    api.GET("/api/chat/thread", {
      params: { query: { limit: PAGE, ...(before === null ? {} : { before_id: before }) } },
    }),
  );
}

/** Show the newest page. False when it could not be read. */
export async function showHistory(): Promise<boolean> {
  try {
    const found = await page(null);
    useChat.getState().showEarlier(found.items, found.next_before_id ?? null);
    return true;
  } catch {
    return false;
  }
}

/** Read the page before the oldest one shown, once at a time. */
export async function loadOlder(): Promise<void> {
  const earlier = useChat.getState().earlier;
  if (!earlier || earlier.loading || earlier.next === null) return;
  useChat.getState().loadingEarlier(true);
  try {
    const found = await page(earlier.next);
    useChat.getState().addOlder(found.items, found.next_before_id ?? null);
  } catch {
    // Left as it was: the next scroll to the top asks again.
    useChat.getState().loadingEarlier(false);
  }
}
